<template>
  <agile :dots="false" :autoplay="true" :autoplay-speed="5000" :fade="true" :navButtons="false">
    <div class="slide">
      <img src="../../public/img/icons/91MountainHomeRoad/outside_night.jpg" />
    </div>
    <div class="slide">
      <img src="../../public/img/icons/dado1/showroomOne.jpg" />
    </div>
    <div class="slide">
      <img src="../../public/img/icons/outdoorProjects/feature3.jpg" />
    </div>
  </agile>
</template>

<script>
export default {}
</script>

<style scoped>
div {
  padding: 0 0 0 0;
}

img {
    max-width: 100%;
}
</style>
